import { modalStore } from '~/mobx/modalStore';
import { userStore } from '~/mobx/userStore';
import client from '~/services/client';
import logger from '~/services/logger';
import { booleanToNumber } from '~/utils/helpers';
import { IAskAgainModal, IAskAgainModalSubmit } from '~/view/containers/Modals/AskAgainModal/AskAgainModal';

export enum AskAgainKey {
  DRAW_POLYGON = 'draw_polygon',
  DELIVERY_PROFILE = 'change_profile_branch_dispatching_rules',
  PREPARATION_PROFILE = 'change_profile_branch_preparation',
  FRANCHISE_PROFILE = 'change_profile_branch_franchise',
  HOURS_PROFILE = 'hours_profile',
}

class AskAgain {
  public get enabledHintMessage(): Record<AskAgainKey, boolean> {
    return {
      [AskAgainKey.DRAW_POLYGON]: !userStore.user.hint_messages?.draw_polygon,
      [AskAgainKey.DELIVERY_PROFILE]: !userStore.user.hint_messages?.change_profile_branch_dispatching_rules,
      [AskAgainKey.PREPARATION_PROFILE]: !userStore.user.hint_messages?.change_profile_branch_preparation,
      [AskAgainKey.FRANCHISE_PROFILE]: !userStore.user.hint_messages?.change_profile_branch_franchise,
      [AskAgainKey.HOURS_PROFILE]: !userStore.user.hint_messages?.change_profile_branch_hours,
    };
  }

  private changeHintMessage(key: AskAgainKey, value: boolean) {
    userStore.hintMessageUpdate({ [key]: booleanToNumber(value) });
  }

  public showModal(modalProps: IAskAgainModal, key: AskAgainKey) {
    if (!this.enabledHintMessage[key]) return false;

    modalStore.openAskAgainModal(modalProps);
  }

  public hideModal(key: AskAgainKey, checkBoxStatus: IAskAgainModalSubmit['checkBoxStatus']) {
    if (checkBoxStatus) this.changeHintMessageSetting(key);

    modalStore.closeAskAgainModal();
  }

  public changeHintMessageSetting = async (key: AskAgainKey) => {
    try {
      this.changeHintMessage(key, true);

      await client.post(`v3/hint-message/${key}/viewed`);
    } catch (error: any) {
      this.changeHintMessage(key, false);
      logger.log({ error });
    }
  };
}

const askAgain = new AskAgain();

export default askAgain;
